module.exports = __webpack_public_path__ + "img/x-logo.c9d69ac.png";